import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular';

import { CoLoader } from '@shared/components/loader';
import { CoPushAlert } from '@shared/components/push-alert';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet, CoLoader, CoPushAlert],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
